/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemDashboardDeviceProvidersModel } from '../../models/system-dashboard-device-providers-model';

export interface SystemDashboardProvidersGet$Params {
  from?: string;
  to?: string;
  allRegions?: boolean;
  integratedSystemId?: string;
  organizationId?: string;
}

export function systemDashboardProvidersGet(http: HttpClient, rootUrl: string, params?: SystemDashboardProvidersGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<SystemDashboardDeviceProvidersModel>> {
  const rb = new RequestBuilder(rootUrl, systemDashboardProvidersGet.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('allRegions', params.allRegions, {});
    rb.query('integratedSystemId', params.integratedSystemId, {});
    rb.query('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<SystemDashboardDeviceProvidersModel>;
    })
  );
}

systemDashboardProvidersGet.PATH = '/SystemDashboard/Providers';
